export default "__VITE_ASSET__b026bebf__"